import { render, staticRenderFns } from "./animateBg.vue?vue&type=template&id=8a860e8e&scoped=true&"
var script = {}
import style0 from "./animateBg.vue?vue&type=style&index=0&id=8a860e8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a860e8e",
  null
  
)

export default component.exports